import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { showError } from '@utils';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'constants/queryKeys';
import { teamsServices } from '@services';
import { useAssignees } from 'hooks/common';
import { normalizeAgents, normalizeTeam } from './utils';

export const useTeamOperations = () => {
  const {
    assignees,
    isLoading: isAssigneesLoading,
    isFetched: isAssigneesFetched,
  } = useAssignees();
  const router = useRouter();
  const teamId = router.query?.teamId;

  const teamResponse = useQuery(
    [QUERY_KEYS.GET_TEAM_KEY, teamId],
    () => teamsServices.getTeam(teamId),
    { enabled: !!teamId && isAssigneesFetched }
  );

  const agents = normalizeAgents(assignees);
  const team = normalizeTeam(teamResponse?.data?.data || []);

  useEffect(() => {
    if (teamResponse.isError) {
      showError(teamResponse?.error);
    }
  }, [teamResponse.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    team,
    teamId,
    agents,
    loading: teamResponse?.isLoading || isAssigneesLoading,
    getTeam: teamResponse.refetch,
  };
};
